export default[
    {
        path: '/mon-contact',
        name: 'mon-contact',    
        component: () => import('@/views/contact-bubblin/MonContact.vue'),
    },
    
]